import React, { useEffect, useState } from "react";

import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineUserAdd, AiOutlineDelete } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { FiEdit2 } from "react-icons/fi";
import { BsArrowLeft } from "react-icons/bs";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style, color } from "../../styles/Style";
import Action from "../../components/Action";
import ContentLoader from "react-content-loader";
import {
  deleteBenCategory,
  getBenCategories,
  addBenCategory,
  updateBenCategory,
} from "../../store/actions/UbudeheCategories";
import { getBeneficiries } from "../../store/actions/BenActions";
import {
  deleteCategory,
  updateCategory,
  addnewCategory,
  getCategories,
} from "../../store/actions/CategoryActions";
import {
  updateHhd,
  addnewHhd,
  getHhdById,
} from "../../store/actions/HhdActions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import changeMonthToText from "../../utils/ChangeMonthToText";
import { ToastContainer } from "react-toastify";
import DownloadBtn from "../../components/DownloadBtn";
import { currentDate } from "../../utils/currentDate";

function Categories() {
  const dispatch = useDispatch();

  // calling beneficiries categories
  const beneficiaries = useSelector((state) => state.beneficiries);
  const ubudeheCategories = useSelector((state) => state.ubudeheCategories);
  const categories = useSelector((state) => state.categories);
  const beneficiaryHhds = useSelector((state) => state.beneficiaryHhds);
  const loaders = useSelector((state) => state.loadersState);

  const [openTab, setOpenTab] = useState(1);
  const [formSlide, setFormSlide] = useState(1);
  // overlays
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
    clearOverlayInput();
  }

  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }

  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedBenCategory) {
    setEditBeneOverlay(!editBenOverlay);
    dispatch(getHhdById(passedBenCategory.houseHoldHead));
    setHhd({
      fullName: beneficiaryHhds.hhd.fullName,
      id: beneficiaryHhds.hhd.id,
      idnumber: beneficiaryHhds.hhd.idnumber,
      numberOfFamilyMembers: beneficiaryHhds.hhd.numberOfFamilyMembers,
    });

    setBeneficiaryCat({
      id: passedBenCategory.id,
      beneficiaryHHDId: {
        idValue: passedBenCategory.houseHoldHead,
      },
      beneficiaryId: {
        idValue: passedBenCategory.beneficiaryId,
      },
      categoryId: {
        idValue: passedBenCategory.categoryId,
      },
      endDate: passedBenCategory.endDate,
      startDate: passedBenCategory.startDate,
    });
  }

  const [addcategori, setAddcategori] = useState(0);
  function addcategoriController() {
    setAddcategori(!addcategori);
  }

  const [editcategori, setEditcategori] = useState(0);
  // dropdowns
  // categori dropdowns
  const [categoriDropdown, setcategoriDropDown] = useState(0);
  // for categori table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "StartDate",
        accessor: "startDate",
      },
      {
        Header: "EndDate",
        accessor: "endDate",
      },
      {
        Header: "Head of family",
        accessor: "hhd",
      },
      {
        Header: "Category",
        accessor: "category",
      },
      {
        Header: "FamilyMembers",
        accessor: "familyMembers",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );
  function clearOverlayInput() {
    dispatch({
      type: "SET_BEN_CATEGORY_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_CATEGORY_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_BEN_HHD_MESSAGE",
      message: "",
    });
    setHhd({
      fullName: "",
      id: "",
      idnumber: "",
      numberOfFamilyMembers: "",
    });
    setBeneficiaryCat({
      id: "",
      beneficiaryHHDId: {
        idValue: "",
      },
      beneficiaryId: {
        idValue: "",
      },
      categoryId: {
        idValue: "",
      },
      endDate: "",
      startDate: "",
      status: "ACTIVE",
    });

    setCategory({
      id: "",
      addedById: {
        idValue: userId,
      },
      categoryName: "",
      createdAt: "",
      description: "",
      relatedProjectId: {
        idValue: 1,
      },
    });
  }
  // transform category data
  let [loadedCategories, setLoadedCategories] = useState([]);

  useEffect(() => {
    setLoadedCategories([]);
    for (let i = 0; i < ubudeheCategories.length; i++) {
      const benCategory = {
        count: i + 1,
        beneficiaryId: ubudeheCategories[i].beneficiary.id,
        beneficiary: ` ${ubudeheCategories[i].beneficiary.firstName}  
        ${ubudeheCategories[i].beneficiary.lastName}`,
        category: ubudeheCategories[i].category.categoryName,
        categoryId: ubudeheCategories[i].category.id,
        familyMembers:
          ubudeheCategories[i].beneficiaryHHD.numberOfFamilyMembers,
        startDate: changeMonthToText(ubudeheCategories[i].startDate),
        endDate: changeMonthToText(ubudeheCategories[i].endDate),
        houseHoldHead: ubudeheCategories[i].beneficiaryHHD.id,
        hhd: (
          <div className="flex flex-col">
            <span>{ubudeheCategories[i].beneficiaryHHD.fullName}</span>
            <span className="font-semibold">
              ({ubudeheCategories[i].beneficiaryHHD.idnumber})
            </span>
          </div>
        ),
        status: (
          <div className="py-1 px-2 rounded text-indigo-500 bg-indigo-50 font-normal fit-content">
            {ubudeheCategories[i].status}
          </div>
        ),
        action: (
          <Action
            editAction={() => {
              editOverlayController(benCategory);
            }}
            deleteAction={() => {
              handleDelete(ubudeheCategories[i].id);
            }}
          />
        ),
      };
      setLoadedCategories((loadedCategories) => [
        ...loadedCategories,
        benCategory,
      ]);
      if (
        loaders.benCategory.deletingAction &&
        loaders.benCategory.deletingAction.deleting
      ) {
        const currentBenCategories = loadedCategories;
        const newData = currentBenCategories.map((benCategory) =>
          benCategory.id === loaders.benCategory.deletingAction.id
            ? {
              ...benCategory,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : benCategory
        );
        setLoadedCategories(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ubudeheCategories, loaders.benCategory.deletingAction]);

  let [loadingBenCategories, setLoadingBenCategories] = useState([]);

  useEffect(() => {
    setLoadingBenCategories([]);
    for (let i = 0; i < 5; i++) {
      const benCat = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        category: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        familyMembers: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        startDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        endDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        hhd: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        status: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingBenCategories((loadingBenCategories) => [
        ...loadingBenCategories,
        benCat,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.benCategory.fetchingLoaders]);

  // getting user id from session
  const userId = JSON.parse(
    `${useSelector((state) => state.auth.session)}`
  ).userId;

  // ben category declaration

  const [beneficiaryCat, setBeneficiaryCat] = useState({
    id: "",
    beneficiaryHHDId: {
      idValue: "",
    },
    beneficiaryId: {
      idValue: "",
    },
    categoryId: {
      idValue: "",
    },
    endDate: "",
    startDate: "",
    status: "ACTIVE",
  });
  // category declaration
  // hhd declaration
  const [hhd, setHhd] = useState({
    fullName: "",
    id: "",
    idnumber: "",
    numberOfFamilyMembers: "",
  });

  const [category, setCategory] = useState({
    id: "",
    addedById: {
      idValue: userId,
    },
    categoryName: "",
    createdAt: "",
    description: "",
    relatedProjectId: {
      idValue: 1,
    },
  });
  function editcategoriController(passedCategory) {
    setEditcategori(!editcategori);
    setCategory({
      id: passedCategory.id,
      addedById: {
        idValue: userId,
      },
      relatedProjectId: {
        idValue: 1,
      },
      categoryName: passedCategory.categoryName,
      createdAt: passedCategory.createdAt,
      description: passedCategory.description,
    });
  }
  // handle ubudehe categories submit
  const handleCategorySubmit = (e) => {
    e.preventDefault();
    if (category.id) {
      const id = category.id;
      const updatedBenCategory = {
        id: category.id,
        addedById: {
          idValue: category.addedById.idValue,
        },
        categoryName: category.categoryName,
        createdAt: category.createdAt,
        description: category.description,
        relatedProjectId: {
          idValue: category.relatedProjectId.idValue,
        },
      };
      dispatch(
        updateCategory(updatedBenCategory, id, closeCategoryAfterUpdating)
      );
    } else {
      dispatch(addnewCategory(category, closeCategoryFormAfterAdding));
    }
  };

  // handle hhd submit
  const handleBenCategorySubmit = (e) => {
    e.preventDefault();
    if (beneficiaryCat.id) {
      // first update hhd
      const catId = hhd.id;
      const updatedHhdCategory = {
        id: hhd.id,
        fullName: hhd.fullName,
        idnumber: hhd.idnumber,
        numberOfFamilyMembers: hhd.numberOfFamilyMembers,
      };
      //
      dispatch(updateHhd(updatedHhdCategory, catId, operationAfterUpdatingHhd));
    } else {
      // first add new house hold head
      dispatch(addnewHhd(hhd, operationAfterAddingHhd));
    }
  };

  function operationAfterUpdatingHhd() {
    const id = beneficiaryCat.id;
    const updatedBenCategory = {
      id: beneficiaryCat.id,
      beneficiaryHHDId: {
        idValue: beneficiaryCat.beneficiaryHHDId.idValue,
      },
      beneficiaryId: {
        idValue: beneficiaryCat.beneficiaryId.idValue,
      },
      categoryId: {
        idValue: beneficiaryCat.categoryId.idValue,
      },
      endDate: beneficiaryCat.endDate,
      startDate: beneficiaryCat.startDate,
      status: beneficiaryCat.status,
    };
    dispatch(
      updateBenCategory(updatedBenCategory, id, closeBenCategoryAfterUpdating)
    );
  }

  function operationAfterAddingHhd(hhdId) {
    const newCategory = {
      ...beneficiaryCat,
      beneficiaryHHDId: {
        idValue: hhdId,
      },
    };

    // add ben category
    dispatch(addBenCategory(newCategory, closeBenCategoryFormAfterAdding));
  }

  // handle delete
  const handleDelete = (id) => {
    dispatch(deleteBenCategory(id));
  };
  // handle delete
  const handleCatDelete = (id) => {
    dispatch(deleteCategory(id));
  };

  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }
  // beneficiries select option
  const categoryOption = [];
  for (let i = 0; i < categories.length; i++) {
    const cat = {
      value: categories[i].id,
      label: categories[i].categoryName,
    };

    categoryOption.push(cat);
  }

  const selectedBeneficiary = beneficiriesOption.find(
    (beneficiary) => beneficiary.value === beneficiaryCat.beneficiaryId.idValue
  );
  // reload beneficiries categories
  useEffect(() => {
    dispatch(getBenCategories());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // reload beneficiries
  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getCategories());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  // closing category after cu
  function closeCategoryFormAfterAdding() {
    addcategoriController();
    setCategory({
      id: "",
      addedById: {
        idValue: userId,
      },
      categoryName: "",
      createdAt: "",
      description: "",
      relatedProjectId: {
        idValue: 1,
      },
    });
  }

  function closeCategoryAfterUpdating() {
    editcategoriController({
      id: "",
      addedById: {
        idValue: userId,
      },
      categoryName: "",
      createdAt: "",
      description: "",
      relatedProjectId: {
        idValue: 1,
      },
    });
  }
  // closing ben home after cu
  function closeBenCategoryFormAfterAdding() {
    benOverlayController();
    setBeneficiaryCat({
      id: "",
      beneficiaryHHDId: {
        idValue: "",
      },
      beneficiaryId: {
        idValue: "",
      },
      categoryId: {
        idValue: "",
      },
      endDate: "",
      startDate: "",
      status: "ACTIVE",
    });
  }

  function closeBenCategoryAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryHHDId: {
        idValue: "",
      },
      beneficiaryId: {
        idValue: "",
      },
      categoryId: {
        idValue: "",
      },
      endDate: "",
      startDate: "",
      status: "ACTIVE",
    });
  }

  function clearErrors() {
    dispatch({
      type: "SET_BEN_CATEGORY_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_CATEGORY_MESSAGE",
      message: "",
    });
  }
  return (
    <DashLayout>
      <div className="mx-10 bg-white">
        <div className="text-xs">
          <ToastContainer />
        </div>
        <div className="flex flex-col md:flex-row p-10 pl-10 pb-0">
          <h2 className="font-semibold">Ubudehe categories </h2>
          <div className="md:m-auto mt-2 md:mr-0">
            <button
              className="p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400 title-tip"
              message="Register"
              onClick={() => {
                benOverlayController();
              }}
            >
              <AiOutlineUserAdd />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
              onClick={() => {
                filterOverlayController();
              }}
            >
              <FiFilter />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
              onClick={() => {
                dispatch(getBenCategories());
              }}
            >
              <FcRefresh
                className={
                  loaders.benCategory.fetchingLoaders ? " refresh-loader" : " "
                }
              />
            </button>


            <DownloadBtn filename={`categories-${changeMonthToText(currentDate())}`} table="table-to-xls" />
          </div>
        </div>
        <div className="pl-10" />
        <div className="pb-5 px-0 pr-10  flex flex-wrap  w-full">
          {/* categori table */}
          <div className="w-full">
            {(!loaders.benCategory.fetchingLoaders &&
              ubudeheCategories.length < 1) |
              loaders.benCategory.fetchFailedMessage ? (
              <div
                className={
                  !loaders.benCategory.fetchFailedMessage
                    ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                    : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                }
              >
                <p>
                  {!loaders.benCategory.fetchFailedMessage
                    ? "No category record found"
                    : loaders.benCategory.fetchFailedMessage}
                </p>
              </div>
            ) : (
              <Table
                data={
                  loaders.benCategory.fetchingLoaders
                    ? loadingBenCategories
                    : loadedCategories
                }
                columns={columns}
              />
            )}{" "}
          </div>
        </div>
        {/*add beneficiary overlay  */}
        <div
          className={
            addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className="bg-white m-auto  rounded">
              <div
                className={
                  loaders.benCategory.message &&
                    (openTab === 1) | loaders.hhd.message &&
                    openTab === 1
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.benCategory.message | loaders.hhd.message}</p>
              </div>

              <div
                className={
                  loaders.category.message && openTab === 2
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.category.message}</p>
              </div>
              <div className="p-10">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {addBenOverlay
                      ? "Categories info registration"
                      : "Change Beneficiary category info"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addBenOverlay
                          ? benOverlayController()
                          : editOverlayController({
                            id: "",
                          });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <ul
                      className="flex mb-0 list-none flex-wrap  font-medium  flex-row w-full border-b border-gray-300"
                      role="tablist"
                    >
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0   block leading-normal" +
                            (openTab === 1
                              ? " text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(1);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link1"
                          role="tablist"
                        >
                          <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                          Beneficiary
                        </a>
                      </li>
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0  block leading-normal " +
                            (openTab === 2
                              ? "text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(2);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link2"
                          role="tablist"
                        >
                          <i className="fas fa-cog text-base mr-1"></i>Ubudehe
                          Categories
                        </a>
                      </li>
                    </ul>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 1 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <form
                              className="flex flex-col pt-3"
                              onSubmit={handleBenCategorySubmit}
                            >
                              <div className="flex flex-col py-3">
                                <div className="flex w-full">
                                  <div
                                    className={
                                      formSlide === 1
                                        ? "px-2 py-1 rounded-full bg-indigo-500 text-white"
                                        : "px-2 py-1 rounded-full bg-gray-100"
                                    }
                                  >
                                    1
                                  </div>
                                  <div className="w-full bg-gray-200 pt-0.5 m-auto " />
                                  <div
                                    className={
                                      formSlide === 2
                                        ? "px-2 py-1 rounded-full bg-indigo-500 text-white"
                                        : "px-2 py-1 rounded-full bg-gray-100"
                                    }
                                  >
                                    2
                                  </div>
                                </div>
                                <div className="flex font-medium">
                                  <div
                                    className={
                                      "mr-auto " +
                                      (formSlide === 1
                                        ? "text-indigo-500"
                                        : "text-gray-500")
                                    }
                                  >
                                    HHD
                                  </div>
                                  <div
                                    className={
                                      "ml-auto " +
                                      (formSlide === 2
                                        ? "text-indigo-500"
                                        : "text-gray-500")
                                    }
                                  >
                                    Category
                                  </div>
                                </div>
                              </div>
                              <div
                                className={formSlide === 2 ? "block" : "hidden"}
                              >
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Beneficiary Id</label>
                                  <Select
                                    options={beneficiriesOption}
                                    value={beneficiriesOption.find(
                                      (obj) =>
                                        obj.value ===
                                        beneficiaryCat.beneficiaryId.idValue
                                    )}
                                    onChange={(e) =>
                                      setBeneficiaryCat({
                                        ...beneficiaryCat,
                                        beneficiaryId: {
                                          idValue: e.value,
                                        },
                                      })
                                    }
                                  />
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={
                                        beneficiaryCat.beneficiaryId.idValue
                                          ? selectedBeneficiary.name
                                          : ""
                                      }
                                      readOnly
                                    />
                                  </div>
                                </div>
                                {/*  field */}
                                <div className="py-2  w-full">
                                  <div className="flex w-full">
                                    <div>
                                      <label>FromDate </label>
                                      <div
                                        className={
                                          style.field.parentDiv + " mr-2 w-1/2"
                                        }
                                      >
                                        <input
                                          type="date"
                                          className={style.field.input}
                                          value={beneficiaryCat.startDate}
                                          onChange={(e) =>
                                            setBeneficiaryCat({
                                              ...beneficiaryCat,
                                              startDate: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="ml-auto">
                                      <label>ToDate </label>
                                      <div
                                        className={
                                          style.field.parentDiv + " w-1/2"
                                        }
                                      >
                                        <input
                                          type="date"
                                          className={style.field.input}
                                          value={beneficiaryCat.endDate}
                                          onChange={(e) =>
                                            setBeneficiaryCat({
                                              ...beneficiaryCat,
                                              endDate: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Ubudehe category</label>
                                  <Select
                                    options={categoryOption}
                                    value={categoryOption.find(
                                      (obj) =>
                                        obj.value ===
                                        beneficiaryCat.categoryId.idValue
                                    )}
                                    onChange={(e) =>
                                      setBeneficiaryCat({
                                        ...beneficiaryCat,
                                        categoryId: {
                                          idValue: e.value,
                                        },
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              {/* other information */}
                              <div
                                className={formSlide === 1 ? "block" : "hidden"}
                              >
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>HHD name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={hhd.fullName}
                                      onChange={(e) =>
                                        setHhd({
                                          ...hhd,
                                          fullName: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>HHD national id </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="number"
                                      className={style.field.input}
                                      value={hhd.idnumber}
                                      onChange={(e) =>
                                        setHhd({
                                          ...hhd,
                                          idnumber: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Family members </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="number"
                                      className={style.field.input}
                                      value={hhd.numberOfFamilyMembers}
                                      onChange={(e) =>
                                        setHhd({
                                          ...hhd,
                                          numberOfFamilyMembers: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="flex w-full">
                                {/* back btn */}
                                <button
                                  type="button"
                                  className={
                                    formSlide === 2 ? style.BackBtn : "hidden"
                                  }
                                  onClick={() => {
                                    setFormSlide(1);
                                  }}
                                >
                                  <p className="m-auto">{"Back"}</p>
                                </button>
                                <button
                                  type="button"
                                  className={
                                    formSlide === 1 ? style.loginBtn : "hidden"
                                  }
                                  onClick={
                                    formSlide === 1
                                      ? () => {
                                        setFormSlide(2);
                                      }
                                      : null
                                  }
                                >
                                  <p className="m-auto">{"Next"}</p>
                                </button>
                                {/* save btn */}
                                <button
                                  type="submit"
                                  className={
                                    formSlide === 2 ? style.loginBtn : "hidden"
                                  }
                                  disabled={
                                    loaders.benCategory.sendingLoader |
                                    loaders.hhd.sendingLoader
                                  }
                                >
                                  {!loaders.benCategory.sendingLoader &
                                    !loaders.hhd.sendingLoader ? (
                                    <p className="m-auto">{"Save"}</p>
                                  ) : (
                                    <div className="spinner m-auto">
                                      <div className="bounce1"></div>
                                      <div className="bounce2"></div>
                                      <div className="bounce3"></div>
                                    </div>
                                  )}{" "}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 2 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <div className="flex w-full  flex-col py-5">
                              <button
                                className={
                                  !addcategori & !editcategori
                                    ? "p-3 text-center bg-indigo-500 hover:bg-indigo-600 rounded text-white font-normal mb-3"
                                    : "hidden"
                                }
                                onClick={() => {
                                  addcategoriController();
                                }}
                              >
                                {"Add category"}
                              </button>
                              <div
                                className={
                                  !addcategori & !editcategori
                                    ? "flex w-full flex-col py-5 pb-0"
                                    : "hidden"
                                }
                              >
                                {loaders.category.fetchingLoaders ? (
                                  <div className="spinner m-auto indigo-spinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                ) : (
                                  categories.map((categori, i) => {
                                    return loaders.category.deletingAction &&
                                      loaders.category.deletingAction.id ===
                                      categori.id ? (
                                      <div className="spinner m-auto red-spinner">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          "border border-gray-300 p-3 mb-3 rounded bg-gray-100 flex"
                                        }
                                        key={i}
                                        onClick={() => {
                                          setcategoriDropDown(i);
                                        }}
                                      >
                                        <div className="flex mb-2 m-auto mx-0 text-start cursor-pointer">
                                          <h2 className="font-semibold m-auto">
                                            {categori.categoryName}
                                          </h2>
                                        </div>
                                        <div
                                          className={
                                            categoriDropdown === i
                                              ? "flex flex-col ml-auto"
                                              : "hidden"
                                          }
                                        >
                                          <div className="flex m-auto fit-content">
                                            <button
                                              className="flex p-1 rounded border border-gray-300 hover:border-gray-300 bg-gray-300 text-gray-500 mr-2"
                                              onClick={() => {
                                                editcategoriController(
                                                  categori
                                                );
                                              }}
                                            >
                                              <FiEdit2 />
                                            </button>
                                            <button className="flex p-1 rounded border border-red-300 hover:border-red-300 bg-red-300 text-red-500 mr-2">
                                              <AiOutlineDelete
                                                onClick={() => {
                                                  handleCatDelete(categori.id);
                                                }}
                                              />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                              {/* add categori */}
                              <form
                                className={
                                  addcategori || editcategori
                                    ? "flex w-full flex-col  pb-0"
                                    : "hidden"
                                }
                                onSubmit={handleCategorySubmit}
                              >
                                <h2 className="font-semibold">
                                  {addcategori
                                    ? "Register category"
                                    : "Change category info"}
                                </h2>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={category.categoryName}
                                      onChange={(e) =>
                                        setCategory({
                                          ...category,
                                          categoryName: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                  <button
                                    type="submit"
                                    className={style.loginBtn}
                                    disabled={loaders.category.sendingLoader}
                                  >
                                    {!loaders.category.sendingLoader ? (
                                      <p className="m-auto">
                                        {addcategori ? "Register" : "Save"}
                                      </p>
                                    ) : (
                                      <div className="spinner m-auto">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    )}
                                  </button>
                                </div>
                                <p
                                  className={
                                    addcategori | editcategori
                                      ? "p-3 pl-0 flex rounded text-indigo-500 font-normal mb-3 cursor-pointer m-auto"
                                      : "hidden"
                                  }
                                  onClick={() => {
                                    addcategori
                                      ? addcategoriController()
                                      : editcategoriController({
                                        id: "",
                                        addedById: {
                                          idValue: userId,
                                        },
                                        categoryName: "",
                                        createdAt: "",
                                        description: "",
                                        relatedProjectId: {
                                          idValue: 1,
                                        },
                                      });
                                  }}
                                >
                                  <BsArrowLeft className="mr-2" /> {"Back"}
                                </p>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>
        {/* filter categori overlay */}
        <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 bg-white m-auto  rounded">
              <div className="flex">
                <h2 className="font-semibold my-2  w-80">
                  Filter Ubudehe categories
                </h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      filterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Beneficiary range </label>
                  <div className="flex w-full">
                    <Select options={beneficiaries} className="w-1/2 mr-2" />

                    <Select options={beneficiaries} className="w-1/2" />
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>FromDate range</label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " w-1/2 mr-2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>ToDate range</label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " w-1/2 mr-2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label> Family members range</label>
                  <div className="flex">
                    <div className={style.field.parentDiv + "w-1/2 mr-2"}>
                      <input type="number" className={style.field.input} />
                    </div>
                    <div className={style.field.parentDiv + "w-1/2"}>
                      <input type="number" className={style.field.input} />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Categories </label>
                  <Select options={beneficiaries} isMulti />
                </div>

                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">Apply</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
      </div>
      <table className="table text-left table-to-export hidden" id="table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary</th>
            <th>Start date</th>
            <th>End date</th>
            <th>Head of family</th>
            <th>Category</th>
            <th>Family members</th>
          </tr>
        </thead>
        <tbody>

          {ubudeheCategories.map((ubudeheCat) =>
            <tr>
              <td>{ubudeheCat.beneficiary.firstName}
                {ubudeheCat.beneficiary.lastName}</td>
              <td>{changeMonthToText(ubudeheCat.startDate)}{" "}</td>
              <td>{changeMonthToText(ubudeheCat.endDate)}{" "}</td>
              <td>{ubudeheCat.beneficiaryHHD.fullName} <br />{" "}
                <b> ({ubudeheCat.beneficiaryHHD.idnumber}{" "})</b></td>
              <td>{ubudeheCat.category.categoryName}{" "}</td>
              <td>{ubudeheCat.beneficiaryHHD.numberOfFamilyMembers}{" "}</td>
            </tr>
          )}
        </tbody>
      </table>
    </DashLayout>
  );
}

export default Categories;
